window.ScrollMemory = {
  save() {
    const path = window.location.pathname;
    // On sauvegarde pour la page d’accueil et les collections
    if (path === '/' || path.includes('/collections/')) {
      try {
        sessionStorage.setItem('scroll:' + path, window.scrollY);
      } catch (e) {}
    }
  },

  restore() {
    const path = window.location.pathname;
    if (path !== '/' && !path.includes('/collections/')) return;

    const pos = sessionStorage.getItem('scroll:' + path);
    if (!pos) return;
    const y = parseInt(pos, 10);
    if (isNaN(y) || y < 0) return;

    let tries = 0;
    const loop = () => {
      tries++;
      if (document.body.scrollHeight > y + 100 || tries > 50) {
        window.scrollTo({ top: y, behavior: 'instant' });
      } else {
        requestAnimationFrame(loop);
      }
    };
    requestAnimationFrame(loop);
  },

  clear() {
    const path = window.location.pathname;
    if (path === '/' || path.includes('/collections/')) {
      try {
        sessionStorage.removeItem('scroll:' + path);
      } catch (e) {}
    }
  },

  bind() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (!a) return;
      const href = a.getAttribute('href') || '';

      // Sauvegarde si on clique vers un produit depuis accueil ou collection
      if (
        (window.location.pathname === '/' || window.location.pathname.includes('/collections/')) &&
        href.includes('/products/')
      ) {
        this.save();
      }

      // Si on clique sur une autre page (ex : retour accueil ou nouvelle collection) → on efface
      if (
        href === '/' && window.location.pathname !== '/' ||
        (href.includes('/collections/') && href !== window.location.pathname)
      ) {
        this.clear();
      }
    });

    // Restauration uniquement sur retour navigateur (pageshow avec persisted)
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        this.restore();
      }
    });
  }
};

window.ScrollMemory.bind();